module.exports = __webpack_public_path__ + "img/close.526eeae8.svg";